import React from "react";
import { Wrench, MessageCircle, Compass, Building2 } from "lucide-react";
import { SITE } from "../../site.config";

const ICONS = [Wrench, MessageCircle, Compass, Building2];

export default function WhyUs() {
  return (
    <section
      data-testid="whyus-section"
      className="relative bg-black py-24 md:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-10 bg-cyan-pz" />
          <span className="bebas text-cyan-pz tracking-[0.3em] text-sm">
            WHY POWERZ
          </span>
        </div>
        <h2 className="bebas text-white text-5xl md:text-7xl leading-[0.9] max-w-4xl mb-16">
          NOT YOUR AVERAGE <span className="text-cyan-pz">SPARKY.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {SITE.whyUs.map((item, i) => {
            const Icon = ICONS[i] || Wrench;
            return (
              <div
                key={item.title}
                data-testid={`why-item-${i}`}
                className="bg-black p-8 lg:p-10 hover:bg-[#0A0A0A] transition-colors group relative"
              >
                <span className="absolute top-6 right-6 bebas text-white/20 text-xl tracking-widest">
                  0{i + 1}
                </span>
                <Icon className="w-10 h-10 text-cyan-pz mb-6 group-hover:scale-110 transition-transform" />
                <h3 className="bebas text-white text-2xl md:text-3xl tracking-wider mb-3">
                  {item.title}
                </h3>
                <p className="text-white/60 barlow text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
